<template>
  <ion-page>
    <ion-content>
      <div class="container ion-padding">
        <div>
          <img :src="require('../../images/logo_large.png')" style="width: 40vw">
        </div>
        <div style="width: 80vw; margin-top: 1vh">
          GIMOLOTT là ứng dụng chăm sóc khách hàng của <br>Công ty TNHH Dịch vụ thương mại KENO88 , TP Biên Hòa, Tỉnh Đồng Nai, Việt Nam, MST: 3603683922 (sau đây gọi là "Công Ty").
        </div>
        <div style="width: 80vw; margin-top: 1vh">
          Ứng dụng ngoài cung cấp chức năng kết nối khách hàng đến các đại lý trực thuộc "Công Ty", còn có các chức năng: dò kết quả xổ số Vietlott và xem kết quả trực tuyến loại hình xổ số Keno.
        </div>
        <div style="width: 80vw; margin-top: 1vh">
          Trước khi bắt đầu sử dụng ứng dụng xin vui lòng xác nhận các điều khoản dưới đây:
        </div>
        <ul>
          <li>Tôi là công dân Việt Nam trên 18 tuổi có đủ hành vi dân sự.</li>
          <li>Tôi hoàn toàn hiểu về <a href="https://vietlott.vn/vi//9272-loi-khuyen-cho-nguoi-choi/">Chơi có trách nhiệm</a>.</li>
          <li>Tôi hiện là khách hàng của một trong những đại lý trực thuộc "Công Ty".</li>
          <li>Tôi đồng ý với <a href="javascript:void(0)" @click="router.push('/info/policy')">Điều khoản và điều kiện sử dụng ứng dụng</a>.</li>
        </ul>
        <div style="width: 80vw; color: #fa0">
          Hãy thoát và gỡ cài đặt ứng dụng này ngay khi bạn không đồng ý hoặc không phù hợp với các điều khoản trên.
        </div>
      </div>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
          <ion-button size="large" expand="block" color="light" @click="agree">
            Tôi xác nhận và đồng ý
          </ion-button>
      </ion-toolbar>
    </ion-footer>
  </ion-page>
</template>

<style scoped>
  ion-page, ion-content, .container {
    background-color: var(--ion-color-primary);
    --background: var(--ion-color-primary);
    color: #fff;
  }
  .container a {
    color: #ff0;
  }
  ion-footer, ion-toolbar {
    --background: #3880ff;
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    /*justify-content: center;*/
    height: 100%;
  }
</style>

<script>
  import {
    IonPage,
    IonContent,
    IonFooter,
    IonButton,
    // IonButtons,
    IonToolbar,
  } from '@ionic/vue';
  import { defineComponent } from 'vue';
  import { useRouter } from 'vue-router';
  import {
    Plugins,
  } from '@capacitor/core';

  export default defineComponent({
    name: "PreConds",
    components: {
      IonPage,
      IonContent,
      IonFooter,
      IonButton,
      // IonButtons,
      IonToolbar,
    },
    setup() {
      const router = useRouter();
      const { Storage } = Plugins;
      return {
        router,
        async agree() {
          await Storage.set({
            key: 'preconds',
            value: 'yes'
          });
          router.push('/');
        }
      }
    },
  });

</script>
